import React from 'react';
import { FadeIn, Section } from './ui';
export function ProductSection() {
  const modules = [{
    num: '01',
    title: '1° de Primaria',
    desc: 'Banco anual de ejercicios de matemática para primer grado. Conteo, sumas, restas, figuras y problemas simples. Listo para fotocopiar o proyectar sin preparación previa.',
    tag: 'TOMO 1'
  }, {
    num: '02',
    title: '2° de Primaria',
    desc: 'Ejercicios de numeración hasta el 1000, sumas y restas con reagrupación, tablas de multiplicar e introducción a la división. Todo organizado por momento del año.',
    tag: 'TOMO 2'
  }, {
    num: '03',
    title: '3° de Primaria',
    desc: 'Multiplicación, división, fracciones simples, medidas y geometría básica. Progresión creciente de dificultad para usar en cualquier momento del ciclo lectivo.',
    tag: 'TOMO 3'
  }, {
    num: '04',
    title: '4° de Primaria',
    desc: 'Numeración hasta el 100.000, multiplicación por dos cifras, fracciones, decimales, porcentajes y área de figuras. Con guía de corrección rápida incluida.',
    tag: 'TOMO 4'
  }, {
    num: '05',
    title: '5° de Primaria',
    desc: 'Operaciones combinadas, divisibilidad, fracciones avanzadas, proporcionalidad, estadística y volumen. Ejercicios listos para usar el día que los necesites.',
    tag: 'TOMO 5'
  }, {
    num: '06',
    title: '6° de Primaria',
    desc: 'Números enteros, fracciones complejas, porcentajes avanzados, álgebra inicial, geometría analítica y probabilidad. El cierre completo del nivel primario.',
    tag: 'TOMO 6'
  }, {
    num: '07',
    title: '1° de Secundaria',
    desc: 'Números enteros, racionales, potencias, proporcionalidad, ecuaciones de primer grado, inecuaciones y geometría. La base del nivel secundario sin improvisación.',
    tag: 'TOMO 7'
  }, {
    num: '08',
    title: '2° de Secundaria',
    desc: 'Polinomios, factoreo, ecuaciones cuadráticas, sistemas de ecuaciones, funciones lineales y trigonometría básica. Ejercicios con guía de corrección lista.',
    tag: 'TOMO 8'
  }, {
    num: '09',
    title: '3° de Secundaria',
    desc: 'Números reales, fracciones algebraicas, función exponencial y logarítmica, trigonometría en el círculo, matrices y probabilidad combinatoria.',
    tag: 'TOMO 9'
  }, {
    num: '10',
    title: '4° de Secundaria',
    desc: 'Números complejos, límites, derivadas, aplicaciones de la derivada, cónicas, combinatoria avanzada y distribución binomial.',
    tag: 'TOMO 10'
  }, {
    num: '11',
    title: '5° de Secundaria',
    desc: 'Derivadas avanzadas, integrales, sucesiones y series, vectores, estadística inferencial, distribuciones de probabilidad y matemática financiera.',
    tag: 'TOMO 11'
  }, {
    num: '12',
    title: '6° de Secundaria',
    desc: 'Análisis matemático, ecuaciones diferenciales, álgebra lineal, cadenas de Markov, regresión estadística, grafos y modelos de optimización lineal.',
    tag: 'TOMO 12'
  }];
  return <Section variant="light" className="!max-w-none" data-id="element-205">
      <div className="max-w-[1100px] mx-auto" data-id="element-206">
        <FadeIn data-id="element-207">
          <h2 className="text-[28px] md:text-4xl font-black text-gray-900 mb-6 text-center" data-id="element-208">
            ¿Qué es exactamente Matemática 360?
          </h2>
          <p className="text-gray-600 text-base md:text-lg mb-12 leading-relaxed text-center max-w-[800px] mx-auto" data-id="element-209">
            Es un sistema de 12 tomos en PDF con ejercicios listos para usar
            cubriendo todo el recorrido escolar: de 1° de Primaria a 6° de
            Secundaria. Un tomo por año, con ejercicios organizados por momento
            del ciclo lectivo, listos para fotocopiar o proyectar sin
            preparación previa.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-210">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-211">
              <div className="bg-white border border-brand-green/30 p-5 md:p-6 rounded-2xl h-full flex flex-col hover:border-brand-green hover:shadow-[0_8px_30px_rgb(5,150,105,0.12)] transition-all duration-300 relative overflow-hidden group" data-id="element-212">
                <div className="absolute top-0 right-0 bg-brand-green text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-213">
                  {mod.tag}
                </div>
                <div className="text-3xl md:text-4xl font-black text-gray-200 mb-1 group-hover:text-brand-green/20 transition-colors" data-id="element-214">
                  {mod.num}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-215">
                  Ejercicios Listos — {mod.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed flex-grow" data-id="element-216">
                  {mod.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}